module.exports = __webpack_public_path__ + "static/media/mini-card.3d20737c.png";